import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './Styles/Styles.scss';
import { Provider } from 'react-redux';
import { setSession } from './Redux/Actions';
import Store from './Redux/Store';
import Routes from './Routes/Routes';
import Helpers from './Helpers/Helpers';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';

const App = () => {
  const [content, setContent] = useState(<div style={{
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }}>
    <img src={Helpers.config.api.images + '/dashboard/preloading.svg'} alt="Preloading" />
  </div>);

  useEffect(() => {
    axios({
      url: Helpers.config.api.url + '/users/session',
      method: 'POST',
      data: {
        jwt: Helpers.localStorage.getJWT()
      }
    }).then(res => {
      return res.data;
    }).then(res => {
      if (res.message === 'error_session_api') {
        localStorage.clear();
        setContent(<Provider store={Store}>
          <Routes type="auth" />
          <ToastContainer />
        </Provider>);
      } else {
        Store.dispatch(setSession(res.data));
        Helpers.localStorage.setSession({
          jwt: res.data.jwt
        });
        setContent(<Provider store={Store}>
          <Routes />
          <ToastContainer />
        </Provider>);
      }
    }).catch(req => {
      console.log(req);
    });
  }, []);

  return content;
}

console.log('%cCARLOS ESTHEFANO HUAMAN MARCOS', 'color: RED; font-size: 20px; font-weight: bold');
console.log('%cDESARROLLADOR DE SISTEMAS', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cPERU', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cCELULAR +51 989998352', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cEMAIL carhuaman1995@gmail.com', 'color: RED; font-size: 15px; font-weight: bold');

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();